import view from '@/mixins/view'

const replace = process.env.VUE_APP_DEV_DIST_URL ? process.env.VUE_APP_DEV_DIST_URL : `${window.location.protocol}//${window.location.hostname}`

export default {
  name: 'single-post',
  mixins: [view],
  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })

      if (this.page.meta.link) {
        if (this.page.meta.link !== this.page.meta.link.replace(replace, '')) {
          this.$router.push(this.getCleanLink(this.page.meta.link))
        } else {
          window.open(this.page.meta.link, '_blank')
        }
      }

      this.$router.push(this.getCleanLink(this.options.pages.home))
    })
  },
  methods: {
    fetchData: async function (store, params) {
      const isPage = params.post_type === 'page'
      return Promise.all([
        store.getters.get('post', params.slug, true)
      ]).then(([page]) => {
        return { page }
      })
    },
    getPage: async function () {
      await this.fetchData(this.$store, Object.assign({}, this.$attrs, this.$route.params)).then(({ page }) => {
        this.page = page
      })
    }
  }
}
